import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';

import {HttpClient} from '@angular/common/http';
import {CostStatuses} from '../models/cost.model';
import {Roles} from '../models/auth/role.model';

@Injectable({
  providedIn: 'root'
})
export class CostActionsService {
  private readonly COST_ACTIONS = costActions;

  constructor(private http: HttpClient) {

  }

  getCostOptions(costStatus: CostStatuses, roles: Roles[], canCurrentUserMakeAction: boolean, hasCreatedThisCost: boolean) {
    return this.findEntry(costStatus, roles, canCurrentUserMakeAction, hasCreatedThisCost);
  }

  private findEntry(costStatus: CostStatuses, roles: Roles[], canCurrentUserMakeAction: boolean, hasCreatedThisCost: boolean) {
    const costActionsByStatus = this.COST_ACTIONS[costStatus];
    let costOptions = [];
    if (costActionsByStatus) {
      costOptions = costActionsByStatus.map(costAction => {
        const hasRole = roles.some(role => {
          if (role !== Roles.User && roles.length > 1) {
            return costAction.roles.includes(role);
          } else {
            return costAction.roles.includes(role);
          }
        });
        // console.log('hasRole', hasRole);
        // console.log('costActionsByStatus', costActionsByStatus);

        if (!hasRole) {
          return null;
        }

        if (canCurrentUserMakeAction || !costAction.canCurrentUserMakeAction) {
          if (costAction.hasCreatedThisCost) {
            if (costAction.hasCreatedThisCost === hasCreatedThisCost) {
              return costAction.options;

            } else {
              return null;
            }
          } else {
            return costAction.options;
          }
        }
      });
    }

    return costOptions.filter(v => !!v);
  }

}

const costActions = {
  'new': [
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': true,
      'roles': [
        'ROLE_USER',
        'ROLE_STAFF',
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'sendForApproval',
        'buttonText': 'Send to approval',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': true,
      'roles': [
        'ROLE_USER',
        'ROLE_STAFF',
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'update',
        'buttonText': 'Save',
        'btnColorClass': 'btn--outline-dark',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': true,
      'roles': [
        'ROLE_USER',
        'ROLE_STAFF',
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'cancel',
        'buttonText': 'Cancel',
        'btnColorClass': ' btn--outline-red',
      }
    }
  ],
  'inApproval': [
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'approve',
        'buttonText': 'Approve',
        'btnColorClass': 'btn--yellow',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': true,
      'roles': [
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'update',
        'buttonText': 'Save',
        'btnColorClass': 'btn--outline-dark',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'reject',
        'buttonText': 'Reject',
        'btnColorClass': ' btn--outline-red',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': true,
      'roles': [
        'ROLE_STAFF',
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'cancel',
        'buttonText': 'Cancel',
        'btnColorClass': ' btn--outline-red',
      }
    },
  ],
  'inMeritoricalApproval': [
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'approve',
        'buttonText': 'Approve',
        'btnColorClass': 'btn--yellow',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'update',
        'buttonText': 'Save',
        'btnColorClass': 'btn--outline-dark',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'reject',
        'buttonText': 'Reject',
        'btnColorClass': ' btn--outline-red',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': true,
      'roles': [
        'ROLE_STAFF',
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'cancel',
        'buttonText': 'Cancel',
        'btnColorClass': ' btn--outline-red',
      }
    }
  ],
  'inFormalApproval': [
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'approve',
        'buttonText': 'Approve',
        'btnColorClass': 'btn--orange',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'update',
        'buttonText': 'Save',
        'btnColorClass': 'btn--outline-dark',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'reject',
        'buttonText': 'Reject',
        'btnColorClass': ' btn--outline-red',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': true,
      'roles': [
        'ROLE_STAFF',
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'cancel',
        'buttonText': 'Cancel',
        'btnColorClass': ' btn--outline-red',
      }
    }
  ],
  'approved': [
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_STAFF',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'print',
        'buttonText': 'Print',
        'btnColorClass': 'btn--pink',
      }
    }
  ],
  'printed': [
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_STAFF',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'export',
        'buttonText': 'Export',
        'btnColorClass': 'btn--violet',
      }
    },
    {
      // 'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_STAFF',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'print',
        'buttonText': 'Print',
        'btnColorClass': 'btn--outline-navy',
      }
    },
  ],
  'exported': [
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_STAFF',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'return',
        'buttonText': 'Return',
        'btnColorClass': 'btn--dark',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_STAFF',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'export',
        'buttonText': 'Export',
        'btnColorClass': 'btn--outline-dark',
      }
    },
    {
      // 'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_STAFF',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'print',
        'buttonText': 'Print',
        'btnColorClass': 'btn--outline-dark',
      }
    },
  ],
  'returned': [
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_STAFF',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'markAsReturned',
        'buttonText': 'Mark as returned',
        'btnColorClass': 'btn--green',
      }
    },
    {
      // 'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_STAFF',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'print',
        'buttonText': 'Print',
        'btnColorClass': 'btn--outline-dark',
      }
    },
  ],
  'settled': [
    {
      // 'canCurrentUserMakeAction': false,
      'hasCreatedThisCost': false,
      'roles': [
        'ROLE_STAFF',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'print',
        'buttonText': 'Print',
        'btnColorClass': 'btn--outline-dark',
      }
    },
  ],
  'rejected': [
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': true,
      'roles': [
        'ROLE_USER',
        'ROLE_STAFF',
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'update',
        'buttonText': 'Update',
        'btnColorClass': 'btn--red',
      }
    },
    {
      'canCurrentUserMakeAction': true,
      'hasCreatedThisCost': true,
      'roles': [
        'ROLE_USER',
        'ROLE_STAFF',
        'ROLE_MANAGER',
        'ROLE_ADMIN'
      ],
      'options': {
        'action': 'cancel',
        'buttonText': 'Cancel',
        'btnColorClass': ' btn--outline-red',
      }
    },
  ],
};


